// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auth_leftContainer__KKG0f {
    width: 100%;
    height: 100%;
    background-color: #333;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 14px;
}

.Auth_leftContainerHeading__W9EiB {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.Auth_leftContainerHeading__W9EiB span {
    text-transform: uppercase;
    font-size: 26px;
    color: #FFFFFFCC;
    font-weight: 700;
    font-family: 'Satoshi', sans-serif;
    letter-spacing: 10px;
}

.Auth_strikedThrough__kTHTG {
    width: 250px;
    height: 1px;
    background-color: #FFFFFFCC;
}

.Auth_leftContainerImage__2-Pyn {
    flex: 1 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
}

.Auth_leftContainerImage__2-Pyn img {
    width: auto;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.Auth_leftContainerCaption__lfXit {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #FFFFFFCC;
    font-family: 'Noto Serif', serif;
    flex-shrink: 0;
}

.Auth_leftContainerCaption__lfXit .Auth_CaptionOne__bIOXD {
    font-size: 34px;
    max-width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.Auth_leftContainerCaption__lfXit .Auth_CaptionTwo__Utu2o {
    display: flex;
    flex-direction: column;
    font-size: 14px;
}

.Auth_rightContainer__E\\+8Jo {
    background: #fff;
    height: 100vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 48px;
    gap: 3rem;
    box-sizing: border-box;
}

.Auth_rightContainer__E\\+8Jo .Auth_logoImg__Vtcsf {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.Auth_rightContainer__E\\+8Jo .Auth_logoImg__Vtcsf img {
    width: 10rem;
}

.Auth_loginText__\\+E7bb {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

.Auth_loginText__\\+E7bb span {
    text-align: center;
    color: #000;
}

.Auth_loginText__\\+E7bb span:first-of-type {
    font-size: 34px;
}

.Auth_loginText__\\+E7bb span:nth-of-type(2) {
    font-size: 14px;
}

/* 130% */
@media (max-width: 1224px) {
    .Auth_rightContainer__E\\+8Jo {
        transform: scale(0.85);
    }

    .Auth_leftContainerHeading__W9EiB span {
        font-size: 22px;
    }

    .Auth_strikedThrough__kTHTG {
        width: 200px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionOne__bIOXD {
        font-size: 26px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionTwo__Utu2o {
        font-size: 12px;
    }

    .Auth_loginText__\\+E7bb span:first-of-type {
        font-size: 28px;
    }

    .Auth_loginText__\\+E7bb span:nth-of-type(2) {
        font-size: 12px;
    }
}

@media (max-width: 1024px) {
    .Auth_rightContainer__E\\+8Jo {
        transform: scale(0.7);
    }
}

/* 160% */
@media (max-width: 960px) {
    .Auth_rightContainer__E\\+8Jo {
        transform: scale(0.75);
    }

    .Auth_rightContainer__E\\+8Jo {
        padding: 0 18px;
        gap: 1.4rem;
    }

    .Auth_leftContainerHeading__W9EiB span {
        font-size: 12px;
    }

    .Auth_strikedThrough__kTHTG {
        width: 150px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionOne__bIOXD {
        font-size: 22px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionTwo__Utu2o {
        font-size: 8px;
    }
}

/* 180% */
@media (max-width: 850px) {
    .Auth_rightContainer__E\\+8Jo {
        transform: scale(0.6);
    }

    .Auth_strikedThrough__kTHTG {
        width: 150px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionOne__bIOXD {
        font-size: 20px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionTwo__Utu2o {
        font-size: 8px;
    }
}

@media (max-width: 750px) {
    .Auth_rightContainer__E\\+8Jo {
        transform: scale(0.55);
    }

    .Auth_strikedThrough__kTHTG {
        width: 150px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionOne__bIOXD {
        font-size: 20px;
    }

    .Auth_leftContainerCaption__lfXit .Auth_CaptionTwo__Utu2o {
        font-size: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Auth.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,SAAS;AACT;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".leftContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #333;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    border-radius: 14px;\r\n}\r\n\r\n.leftContainerHeading {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    gap: 10px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.leftContainerHeading span {\r\n    text-transform: uppercase;\r\n    font-size: 26px;\r\n    color: #FFFFFFCC;\r\n    font-weight: 700;\r\n    font-family: 'Satoshi', sans-serif;\r\n    letter-spacing: 10px;\r\n}\r\n\r\n.strikedThrough {\r\n    width: 250px;\r\n    height: 1px;\r\n    background-color: #FFFFFFCC;\r\n}\r\n\r\n.leftContainerImage {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    overflow: hidden;\r\n}\r\n\r\n.leftContainerImage img {\r\n    width: auto;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n}\r\n\r\n.leftContainerCaption {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    color: #FFFFFFCC;\r\n    font-family: 'Noto Serif', serif;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.leftContainerCaption .CaptionOne {\r\n    font-size: 34px;\r\n    max-width: 100%;\r\n    word-wrap: break-word;\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n.leftContainerCaption .CaptionTwo {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 14px;\r\n}\r\n\r\n.rightContainer {\r\n    background: #fff;\r\n    height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    padding: 0 48px;\r\n    gap: 3rem;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.rightContainer .logoImg {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.rightContainer .logoImg img {\r\n    width: 10rem;\r\n}\r\n\r\n.loginText {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.loginText span {\r\n    text-align: center;\r\n    color: #000;\r\n}\r\n\r\n.loginText span:first-of-type {\r\n    font-size: 34px;\r\n}\r\n\r\n.loginText span:nth-of-type(2) {\r\n    font-size: 14px;\r\n}\r\n\r\n/* 130% */\r\n@media (max-width: 1224px) {\r\n    .rightContainer {\r\n        transform: scale(0.85);\r\n    }\r\n\r\n    .leftContainerHeading span {\r\n        font-size: 22px;\r\n    }\r\n\r\n    .strikedThrough {\r\n        width: 200px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionOne {\r\n        font-size: 26px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionTwo {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .loginText span:first-of-type {\r\n        font-size: 28px;\r\n    }\r\n\r\n    .loginText span:nth-of-type(2) {\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    .rightContainer {\r\n        transform: scale(0.7);\r\n    }\r\n}\r\n\r\n/* 160% */\r\n@media (max-width: 960px) {\r\n    .rightContainer {\r\n        transform: scale(0.75);\r\n    }\r\n\r\n    .rightContainer {\r\n        padding: 0 18px;\r\n        gap: 1.4rem;\r\n    }\r\n\r\n    .leftContainerHeading span {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .strikedThrough {\r\n        width: 150px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionOne {\r\n        font-size: 22px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionTwo {\r\n        font-size: 8px;\r\n    }\r\n}\r\n\r\n/* 180% */\r\n@media (max-width: 850px) {\r\n    .rightContainer {\r\n        transform: scale(0.6);\r\n    }\r\n\r\n    .strikedThrough {\r\n        width: 150px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionOne {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionTwo {\r\n        font-size: 8px;\r\n    }\r\n}\r\n\r\n@media (max-width: 750px) {\r\n    .rightContainer {\r\n        transform: scale(0.55);\r\n    }\r\n\r\n    .strikedThrough {\r\n        width: 150px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionOne {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .leftContainerCaption .CaptionTwo {\r\n        font-size: 8px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftContainer": `Auth_leftContainer__KKG0f`,
	"leftContainerHeading": `Auth_leftContainerHeading__W9EiB`,
	"strikedThrough": `Auth_strikedThrough__kTHTG`,
	"leftContainerImage": `Auth_leftContainerImage__2-Pyn`,
	"leftContainerCaption": `Auth_leftContainerCaption__lfXit`,
	"CaptionOne": `Auth_CaptionOne__bIOXD`,
	"CaptionTwo": `Auth_CaptionTwo__Utu2o`,
	"rightContainer": `Auth_rightContainer__E+8Jo`,
	"logoImg": `Auth_logoImg__Vtcsf`,
	"loginText": `Auth_loginText__+E7bb`
};
export default ___CSS_LOADER_EXPORT___;
